import '../application';

function shaveePage () {
  const $slidesCont = $('.section-tips');
  const $slides = $slidesCont.find('li');
  const numberOfSlides = 5;
  const $forward = $slidesCont.find('#forward');
  const $backward = $slidesCont.find('#backward');
  const $nav = $slidesCont.find('nav');
  let currentSlide = 0;

  $nav.addClass('show');

  $slides.hide();
  $slides.eq(currentSlide).show();

  $slidesCont.addClass('js');

  $nav.on('click', 'a', function (e) {
    const linkIndex = $nav.find('a').index($(this));

    if (currentSlide < linkIndex) { // slide right
      slide('right', linkIndex);
    } else if (currentSlide > linkIndex) {
      slide('left', linkIndex);
    }

    return false;
  });

  $slidesCont.touchwipe({
    wipeLeft: function () { slide('right'); },
    wipeRight: function () { slide('left'); }
  });

  $forward.click(function (e) { slide('right'); });

  $backward.click(function (e) { slide('left'); });

  function slide (direction, nextSlideIndex) {
    let nextSlideI = nextSlideIndex;
    $nav.find('a').eq(currentSlide).removeClass('selected');
    if (direction === 'left' && currentSlide > 0) {
      nextSlideI = (!nextSlideI && nextSlideI !== 0) ? currentSlide - 1 : nextSlideI;
      const $current = $slides.eq(currentSlide);
      const $last = $slides.eq(nextSlideI);

      $current.slideOut('right');
      $last.slideIn('left');
      currentSlide = nextSlideI;

      if (currentSlide === 0) { $backward.prop('disabled', true); }
      $forward.prop('disabled', false);
    } else if (numberOfSlides - 1 > currentSlide) {
      nextSlideI = (!nextSlideI && nextSlideI !== 0) ? currentSlide + 1 : nextSlideI;
      const $current = $slides.eq(currentSlide);
      const $next = $slides.eq(nextSlideI);

      $current.slideOut('left');
      $next.slideIn('right');
      currentSlide = nextSlideI;

      $backward.prop('disabled', false);
      if (currentSlide === numberOfSlides - 1) { $forward.prop('disabled', true); }
    }
    $nav.find('a').eq(currentSlide).addClass('selected');
    $slidesCont.attr('data-slide', currentSlide);
  }
}

$.fn.extend({
  slideIn: function (dir) {
    let left = 'auto';
    let right = 'auto';

    if (dir === 'left') { left = -60; } else { right = -60; }

    this.css({
      left,
      right,
      opacity: 0,
      display: 'block',
      position: 'absolute',
      top: 0
    });

    this.parent().animate({ height: this.height() });

    return this.animate({
      opacity: 1,
      left: (left !== 'auto') ? 0 : left,
      right: (right !== 'auto') ? 0 : right
    }, function () {
      $(this).css({ position: 'relative' });
    });
  },
  slideOut: function (dir) {
    let left = 'auto';
    let right = 'auto';

    if (dir === 'left') {
      left = -60;
    } else {
      right = -60;
    }

    this.css({
      left: (left !== 'auto') ? 0 : left,
      right: (right !== 'auto') ? 0 : right
    });

    return this.animate({
      left,
      right,
      opacity: 0
    }, function () {
      $(this).css('display', 'none');
    });
  }
});

(function ($) {
  $.fn.touchwipe = function (settings) {
    const config = {
      min_move_x: 20,
      min_move_y: 20,
      wipeLeft: function () { },
      wipeRight: function () { },
      wipeUp: function () { },
      wipeDown: function () { },
      preventDefaultEvents: false
    };

    if (settings) { $.extend(config, settings); }

    this.each(function () {
      let startX;
      let startY;
      let isMoving = false;

      function cancelTouch () {
        this.removeEventListener('touchmove', onTouchMove);
        startX = null;
        isMoving = false;
      }

      function onTouchMove (e) {
        if (config.preventDefaultEvents) {
          e.preventDefault();
        }
        if (isMoving) {
          const x = e.touches[0].pageX;
          const y = e.touches[0].pageY;
          const dx = startX - x;
          const dy = startY - y;
          if (Math.abs(dx) >= config.min_move_x) {
            cancelTouch();
            if (dx > 0) {
              config.wipeLeft();
            } else {
              config.wipeRight();
            }
          } else if (Math.abs(dy) >= config.min_move_y) {
            cancelTouch();
            if (dy > 0) {
              config.wipeDown();
            } else {
              config.wipeUp();
            }
          }
        }
      }

      function onTouchStart (e) {
        if (e.touches.length === 1) {
          startX = e.touches[0].pageX;
          startY = e.touches[0].pageY;
          isMoving = true;
          this.addEventListener('touchmove', onTouchMove, false);
        }
      }
      if ('ontouchstart' in document.documentElement) {
        this.addEventListener('touchstart', onTouchStart, false);
      }
    });

    return this;
  };
  shaveePage();
})(jQuery);
